import environment from '@/environment';
import { networkRequest, createHeaders } from '@/api/api-utils';
import { sceneConfigSchema, SceneData } from '@/schemas/sceneDataSchema';
import { clientInitSchema } from '@/schemas/clientInitSchema';
import { decodeSubmission } from '@/schemas/validation/ValidationSchemaGenerator';

const authDenyList = ['bridge_auth_id', 'partner_public_id', 'auth', 'bridge_token'];

export async function initClient() {
  const query = new URLSearchParams(window.location.search);
  const url = new URL('quote/init', environment.serverBaseUrl);

  query.forEach((value, key) => {
    if (authDenyList.includes(key)) {
      return;
    }

    url.searchParams.append(key, value);
  });

  // Add query params if present
  const partner_public_id = query.get('bridge_auth_id');
  if (partner_public_id) {
    url.searchParams.append('partner_public_id', partner_public_id);
  }

  const bridge_token = query.get('auth');
  if (bridge_token) {
    url.searchParams.append('bridge_token', bridge_token);
  }

  const headers = createHeaders();
  const responseData = await networkRequest(new Request(url, { method: 'GET', headers }));

  return clientInitSchema.parse(responseData);
}

export const getStep = async (entity_index?: number, step_id?: string): Promise<SceneData> => {
  const url = new URL('quote', environment.serverBaseUrl);

  if (entity_index !== undefined && step_id !== undefined) {
    url.searchParams.append('step_id', step_id);
    url.searchParams.append('entity_index', entity_index.toString());
  }

  const responseData = await networkRequest(new Request(url, { method: 'GET', headers: createHeaders() }));

  return sceneConfigSchema.parse(responseData);
};

export const persistStep = async (
  stepId: string,
  entityIndex: number,
  pendingChanges: Record<string, unknown>
): Promise<SceneData> => {
  const url = new URL(`steps/${stepId}`, environment.serverBaseUrl);
  const responseData = await networkRequest(
    new Request(url, {
      method: 'PUT',
      headers: createHeaders(),
      // Server reads params[:data] using the same nested scoped format as form submission.
      // decodeSubmission transforms { "scope=x&attribute=y&entity_index=0": val } →
      // { x: { "0": { y: val } } } which matches what _patch_data expects.
      body: JSON.stringify({ entity_index: entityIndex, data: decodeSubmission(pendingChanges) }),
    })
  );

  return sceneConfigSchema.parse(responseData);
};

export const submitStep = async (
  data: Record<string, Record<string, unknown>>,
  entity_index: number,
  step_id: string
): Promise<SceneData> => {
  const body = {
    entity_index,
    step_id,
    data,
  };

  const url = new URL('quote', environment.serverBaseUrl);
  const responseData = await networkRequest(
    new Request(url, {
      method: 'POST',
      headers: createHeaders(),
      body: JSON.stringify(body),
    })
  );

  return sceneConfigSchema.parse(responseData);
};
